import SyntheticMasthead from "./SyntheticMasthead";
import AnimatedShadows from "../LandingPage/AnimatedShadow";

const SyntheticHome: React.FC = () => {
  return (
    <main className="bg-[#131C34] text-white w-full overflow-x-hidden font-sans relative">
      <AnimatedShadows />
      <div className="relative z-10">
        <div className="relative">
          <SyntheticMasthead />
        </div>
      </div>
    </main>
  );
};

export default SyntheticHome; 